import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModulosRoutingModule } from './modulos-routing.module';
import { ImportsModule } from 'src/app/modules/shared/imports/imports.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModulosComponent } from './components/modulos/modulos.component';
import { OpcionesMenuComponent } from './components/opciones/opciones-menu.component';
import { OpcionesMenuService } from './services/opciones.service';
import { ModulosService } from './services/modulos.service';
import { RolesComponent } from './components/roles/roles.component';

@NgModule({
  declarations: [
    ModulosComponent,
    OpcionesMenuComponent,
    RolesComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ModulosRoutingModule,
    ImportsModule,
  ],
  providers: [
    ModulosService,
    OpcionesMenuService,
  ]
})
export class ModulosModule { }